import React from "react";
import { Button } from "react-bootstrap";
import { FaSun, FaMoon } from "react-icons/fa";

const ThemeToggle = ({ isDark, toggleTheme }) => {
  return (
    <Button
      variant={isDark ? "outline-light" : "outline-dark"}
      className="ms-3 d-flex align-items-center justify-content-center"
      onClick={toggleTheme}
    >
      {isDark ? <FaSun size={18} /> : <FaMoon size={18} />}
    </Button>
  );
};

export default ThemeToggle;
